(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["arena-flash20-offer"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('arena-flash20')) {
    customElements.define('arena-flash20', class extends HTMLElement {
      connectedCallback() {
        if (this.controller) return;
        this.controller = new AbortController();
        const options = { signal: this.controller.signal };
        const prices = JSON.parse(this.querySelector('[data-flash20-variants]').textContent);
        const root = this.closest('[data-aa-product]') || this.closest('.shopify-section');
        root?.addEventListener('change', (event) => {
          if (event.target.name !== 'id') return;
          const price = prices[event.target.value];
          if (price) this.querySelector('[data-flash20-price]').textContent = price.replace(/<[^>]*>/g, '');
        }, options);
        this.querySelector('button').addEventListener('click', async () => {
          const status = this.querySelector('[role="status"]');
          try {
            await navigator.clipboard.writeText('FLASH20');
            status.textContent = this.dataset.copied;
          } catch {
            status.textContent = this.dataset.fallback;
          }
        }, options);
      }
      disconnectedCallback() { this.controller?.abort(); this.controller = null; }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["arena-product-components"] && !Shopify.designMode) return;
  try {
    document.querySelectorAll('[data-aa-product]').forEach((root)=>{const media=[...root.querySelectorAll('[data-media]')],thumbs=[...root.querySelectorAll('[data-thumb]')];let current=0;const show=(i)=>{if(!media.length)return;current=(i+media.length)%media.length;media.forEach((el,n)=>el.classList.toggle('is-active',n===current));thumbs.forEach((el,n)=>el.classList.toggle('is-active',n===current))};thumbs.forEach((el)=>el.addEventListener('click',()=>show(Number(el.dataset.thumb))));root.querySelector('[data-prev]')?.addEventListener('click',()=>show(current-1));root.querySelector('[data-next]')?.addEventListener('click',()=>show(current+1));root.querySelector('[data-variant]')?.addEventListener('change',(e)=>{const price=root.querySelector('[data-price]'),option=e.target.selectedOptions[0];if(price&&option?.dataset.price)price.textContent=option.dataset.price});const sticky=root.querySelector('[data-sticky]'),top=root.querySelector('.aa-product__top');if(sticky&&top)new IntersectionObserver(([entry])=>sticky.classList.toggle('is-visible',!entry.isIntersecting)).observe(top);root.querySelector('[data-sticky-add]')?.addEventListener('click',()=>root.querySelector('.aa-product__add')?.click())});
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["arena-sale-countdown"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('arena-sale-countdown')) {
    customElements.define('arena-sale-countdown', class extends HTMLElement {
      connectedCallback() {
        clearInterval(this.timer);
        const input = this.dataset.end.trim();
        this.end = /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}(:\d{2})?(Z|[+-]\d{2}:\d{2})$/.test(input) ? Date.parse(input) : NaN;
        if (!Number.isFinite(this.end)) {
          if (this.dataset.editor === 'true') {
            this.hidden = false;
            this.querySelector('[data-error]').hidden = false;
            this.querySelector('.aa-sale-timer__units').hidden = true;
          }
          return;
        }
        const deadline = this.querySelector('[data-deadline]');
        const date = new Intl.DateTimeFormat('en-GB', {timeZone:'Europe/London',day:'numeric',month:'long',year:'numeric',hour:'2-digit',minute:'2-digit',hourCycle:'h23'}).format(this.end);
        deadline.textContent = deadline.dataset.format.replace('__DATE__', date);
        this.units = ['days','hours','minutes','seconds'].map(unit => this.querySelector('[data-unit="'+unit+'"]'));
        if (this.update()) this.timer = setInterval(() => this.update(), 1000);
      }
      update() {
        const remaining = Math.max(0, Math.ceil((this.end - Date.now()) / 1000));
        if (!remaining) {
          this.hidden = true;
          clearInterval(this.timer);
          return false;
        }
        const values = [Math.floor(remaining/86400), Math.floor(remaining%86400/3600), Math.floor(remaining%3600/60), remaining%60];
        this.units.forEach((node,index) => { node.textContent = String(values[index]).padStart(2,'0'); });
        this.hidden = false;
        return true;
      }
      disconnectedCallback() { clearInterval(this.timer); }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
